import React from "react";
import { Col } from "react-bootstrap";
import { connect } from "react-redux";
import { formatDate } from "../../../utils/Utils";
const TemplateImage = (props)=>{
    const {template,t} = props;
    return (
        <>
            <Col xs={12}>
                <img src={template.image} alt="" className="template-detail-image img-thumbnail"/>
            </Col>
            <Col xs={12} sm={12} className="bot-created-div">
                <ul>
                    <li>{t("bot-listed-on")}: {formatDate(template.created_at)}</li>
                    <li>{t("last-updated-on")}: {formatDate(template.updated_at)}</li>
                </ul>
            </Col>
        </>
    )
}
export default connect(null,{})(TemplateImage)